import { createContext, useContext } from 'react';

// 由于同步块下的subnodes需要知道它在哪个同步块里面，因此需要这个context
export const SyncContext = createContext<string | undefined>(undefined);
export const useSyncId = () => {
  return useContext(SyncContext);
};
